<template>
    <app-layout>
        <template #header>
            <div class="flex flex-row justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <em class="fas fa-credit-card"></em> Cartão
                </h2>
                <balance :short="true" />
            </div>
        </template>
        <div class="my-20">
            <flash :timeout="5000" />
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg py-4">
                    <div class="flex flex-col items-center justify-center">
                        <div v-if="verifyProduct && !verifyCardActive" class="flex flex-col items-center gap-5">
                            <div class="font-extrabold text-2xl text-black text-opacity-70  max-w-max border-b-2 border-yellow-400">
                                Prontinho
                            </div>
                            <div class="text-black text-opacity-60 text-base mb-2">
                                Seu cartão já pode ser utilizado
                            </div>
                        </div>

                        <div class="self-stretch">
                            <img
                                class="mx-auto"
                                src="images/Cartoes.png"
                                width="300"
                            />
                        </div>

                        <div class="mt-9">

                            <div class="flex flex-col justify-center gap-5">
                                <div v-if="!verifyProduct"
                                    class="font-extrabold text-2xl text-black text-opacity-70  max-w-max border-b-2 border-yellow-400"
                                >
                                    Conheça os benefícios do cartão {{$page.props.white_label.data.short_name}}
                                </div>
                                <div v-else-if="verifyCardActive"
                                    class="font-extrabold text-2xl text-black text-opacity-70  max-w-max border-b-2 border-yellow-400"
                                >
                                    Atualmente, não existe nenhum cartão ativo
                                </div>

                                <div v-else-if="verifyProduct && !verifyCardActive"
                                    class="text-black text-opacity-60 text-base"
                                >
                                    Agora você pode aproveitar todos os
                                    benefícios do seu cartão.
                                </div>
                                <div v-if="!verifyProduct || verifyCardActive"
                                    class="text-black text-opacity-60 text-base"
                                >
                                    A liberdade do cartão de crédito com a
                                    praticidade do débito.
                                </div>
                                <div class="flex gap-4 items-center text-black text-opacity-60">
                                    <span class="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200">
                                        <i class="fas fa-credit-card" />
                                    </span>
                                    <span class="text-base">
                                        Faça compras na função crédito usando o
                                        saldo da sua conta.
                                    </span>
                                </div>
                                <div class="flex gap-4 items-center text-black text-opacity-60">
                                    <span class="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200">
                                        <i class="fas fa-file-invoice-dollar" />
                                    </span>
                                    <span class="text-center text-base ">
                                        Não se preocupe com a fatura no final do
                                        mês.
                                    </span>
                                </div>
                                <div class="flex gap-4 items-center text-black text-opacity-60">
                                    <span class="flex justify-center items-center w-10 h-10 rounded-full bg-gray-200">
                                        <i class="fas fa-money-bill-wave" />
                                    </span>
                                    <span class="text-center text-base">
                                        Faça saques na rede Banco 24h.
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="text-sm text-left px-6 py-4 mt-5 mb-12">
                            <button-confirmation v-if="!verifyProduct" @click.native="handleOrderNow()">
                                Solicitar agora
                            </button-confirmation>
                            <button-confirmation v-else @click.native="goListRequest()">
                             {{verifyCardActive ? 'Solicitar novo cartão' : 'Concluir'}}
                            </button-confirmation>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import ptBR from "vuejs-datepicker/dist/locale";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";
import ButtonConfirmation from '../../Jetstream/ButtonConfirmation.vue';

export default {
    components: {
        Flash,
        Balance,
        AppLayout,
        Welcome,
        ButtonConfirmation
    },
    props: ["account", "customer"],
    data() {
        return {
            ptBR: ptBR
        };
    },
    computed: {
        verifyProduct() {
            return (
                this.account?.prepaid_cards instanceof Array &&
                this.account.prepaid_cards.length > 0
            );
        },
        verifyCardActive() {
          return this.account.prepaid_cards.some(item => item.status !== 'active') ?? false
        }
    },
    methods: {
        handleOrderNow() {
            return this.$inertia.get(this.route("card.confirmation-address"));
        },
        goListRequest() {
            return this.$inertia.get(this.route("card.requests-list"));
        }
    }
};
</script>
